import { createContext, useContext, useState } from 'react';

interface PageContextValue {
  projectName: string | undefined;
  setProjectName: (name: string | undefined) => void;
}

const PageContext = createContext<PageContextValue>({
  projectName: undefined,
  setProjectName: () => undefined,
});

export const usePageContext = (): PageContextValue => useContext(PageContext);

export const PageProvider = ({ children }: { children: React.ReactNode }): React.ReactElement => {
  const [projectName, setProjectName] = useState<string | undefined>(undefined);
  return <PageContext.Provider value={{ projectName, setProjectName }}>{children}</PageContext.Provider>;
};
